import React from 'react';
import { ModalProvider as ModalProviderRaw } from 'styled-react-modal';
import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import Div100vh from 'react-div-100vh';

export const MODAL_BACKDROP_Z_INDEX = 10500;

const ModalBackground = styled(Div100vh)`
  display: flex;
  position: fixed;
  width: 100vw;
  z-index: ${MODAL_BACKDROP_Z_INDEX};
  background: #00000040;
  align-items: flex-end;
  justify-content: center;
  top: 0;

  ${media.sm`
    align-items: center;
  `}
`;

export const ModalProvider = (props) => (
  <ModalProviderRaw backgroundComponent={ModalBackground} {...props} />
);
